import React from "react";

/**
 * Renders a client_narrative JSON payload as the client sees it.
 * Accepts both `narrative` (client_narrative object) and optional `headline`
 * (which often lives at the parent row level in the API).
 */
export default function NarrativeReader({ narrative, headline }) {
  if (!narrative) return <div className="empty">No narrative yet.</div>;
  const { wins, visibility_summary, engagement_summary,
          conversion_summary, geo_snapshot, plain_text } = narrative;

  return (
    <div className="narrative">
      {headline && <p className="headline">{headline}</p>}

      {wins && wins.length > 0 && (
        <div className="section">
          <div className="section-label">This month's wins</div>
          <ul className="win-list">
            {wins.map((w, i) => (
              <li key={i}>
                <div className="title">{w.title}</div>
                {w.detail && <div>{w.detail}</div>}
                {w.metric && <div className="metric">{w.metric}</div>}
              </li>
            ))}
          </ul>
        </div>
      )}

      {plain_text && (
        <div className="section">
          <div className="section-label">The story</div>
          <div className="plain">
            {plain_text.split(/\n\n+/).map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>
      )}

      {[
        ["Visibility", visibility_summary],
        ["Engagement", engagement_summary],
        ["Conversion", conversion_summary],
        ["AI search (GEO)", geo_snapshot],
      ].filter(([, v]) => v && v.trim()).map(([label, v]) => (
        <div className="section" key={label}>
          <div className="section-label">{label}</div>
          <p>{v}</p>
        </div>
      ))}
    </div>
  );
}
